import request from '@/utils/request'
import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_API || '/api/v1'

/**
 * 通过 OpenIddict password grant 登录
 */
export function login(data) {
  const params = new URLSearchParams()
  params.append('grant_type', 'password')
  params.append('client_id', 'CarbonManagement_Web')
  params.append('username', data.userNameOrEmailAddress)
  params.append('password', data.password)
  params.append('scope', 'openid profile email phone roles CarbonManagement offline_access')

  // 直接用 axios 而不是 request（因为 connect/token 不在 /api/ 下）
  return axios.post('/connect/token', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 刷新 Token
 */
export function refreshToken(refreshTokenValue) {
  const params = new URLSearchParams()
  params.append('grant_type', 'refresh_token')
  params.append('client_id', 'CarbonManagement_Web')
  params.append('refresh_token', refreshTokenValue)

  return axios.post('/connect/token', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
  return request({
    url: '/api/auth/user-info',
    method: 'get'
  })
}

/**
 * 获取验证码
 */
export function getCaptcha() {
  return request({
    url: '/api/auth/captcha',
    method: 'get'
  })
}
